import classnames from 'classnames';

export type SizeType = 'min' | 'normal' | 'max';

type DistanceDirectionType = 'left' | 'right' | 'top' | 'bottom' | 'vertical' | 'horizontal';

type InnerDistanceType = Partial<Record<DistanceDirectionType, SizeType | true>>;

export type DistanceType = boolean | InnerDistanceType;

function factoryDistanceClassname(distanceType: 'margin' | 'padding') {
  return function generateDistanceClassname(distanceDirection: DistanceDirectionType, distanceSize?: SizeType) {
    if (distanceSize == null) return undefined;

    if (typeof distanceSize === 'boolean') {
      return distanceSize ? `common-${distanceType}-${distanceDirection}` : undefined;
    }

    if (distanceSize === 'normal') return `common-${distanceType}-${distanceDirection}`;

    return `${distanceSize}-common-${distanceType}-${distanceDirection}`;
  };
}

function commonDistance(marginOrPadding: 'margin' | 'padding', distance: DistanceType, size: SizeType) {
  const generateDistanceClassname = factoryDistanceClassname(marginOrPadding);

  let innerMargin: InnerDistanceType;

  if (typeof distance === 'boolean') {
    innerMargin = distance ? { vertical: size, horizontal: size } : {};
  } else {
    innerMargin = distance;
  }

  return classnames(
    generateDistanceClassname('top', getDistanceSize(size, innerMargin.top ?? innerMargin.vertical)),
    generateDistanceClassname('left', getDistanceSize(size, innerMargin.left ?? innerMargin.horizontal)),
    generateDistanceClassname('bottom', getDistanceSize(size, innerMargin.bottom ?? innerMargin.vertical)),
    generateDistanceClassname('right', getDistanceSize(size, innerMargin.right ?? innerMargin.horizontal))
  );

  function getDistanceSize(distanceSize: SizeType, innerDistance?: SizeType | boolean): SizeType | undefined {
    if (innerDistance == null) return innerDistance;

    if (typeof innerDistance === 'boolean') return innerDistance ? distanceSize : undefined;

    return innerDistance;
  }
}

// console.log('zzz', commonDistance('margin', true, 'normal'));
// console.log('zzz', commonDistance('padding', true, 'normal'));
// console.log('zzz', commonDistance('padding', true, 'large'));
// console.log('zzz', commonDistance('margin', true, 'large'));
// console.log('zzz', commonDistance('padding', true, 'min'));
// console.log('zzz', commonDistance('margin', true, 'min'));
// console.log('zzz', commonDistance('padding', { horizontal: true, vertical: true }, 'min'));
// console.log('zzz', commonDistance('margin', { horizontal: true, vertical: true }, 'min'));
// console.log('zzz', commonDistance('padding', { horizontal: 'large', vertical: 'min' }, 'min'));
// console.log('zzz', commonDistance('padding', { vertical: 'min' }, 'min'));
// console.log('zzz', commonDistance('padding', { vertical: 'large' }, 'min'));
// console.log('zzz', commonDistance('padding', { vertical: true }, 'normal'));

// console.log('zzz', commonDistance('margin', { horizontal: 'large', vertical: 'min' }, 'min'));
// console.log('zzz', commonDistance('margin', { vertical: 'min' }, 'min'));
// console.log('zzz', commonDistance('margin', { vertical: 'large' }, 'min'));
// console.log('zzz', commonDistance('margin', { vertical: true }, 'normal'));

// console.log('zzz', commonDistance('margin', { top: true }, 'normal'));
// console.log('zzz', commonDistance('margin', { top: true }, 'min'));
// console.log('zzz', commonDistance('margin', { top: true }, 'large'));

// console.log('zzz', commonDistance('padding', { top: true }, 'normal'));
// console.log('zzz', commonDistance('padding', { top: true }, 'min'));
// console.log('zzz', commonDistance('padding', { top: true }, 'large'));

export default commonDistance;
